// src/pages/ZillaParentDashboard.tsx
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MomPage from "../MomPage";

import { RootState } from "../../../store";
import ZillaDashboard1 from "./ZillaDashboard1";
import ZillaDashboard2 from "./ZillaDashboard2";

interface ParentProps {
  finYear: string;
  meetingType: any;
}

const ZillaParentDashboard: React.FC<ParentProps> = ({ finYear, meetingType }) => {
  const zillaData = useSelector(
    (state: RootState) => state.common.dashboardData["Zilla Panchayats"]
  );

  const isStateSelected =
    zillaData?.state_code !== null && zillaData?.state_name !== "";
  const isZpSelected =
    zillaData?.zp_lgd_code !== null && zillaData?.zp_name !== "";

  return (
    <>
      {!isStateSelected ? (
        <ZillaDashboard1 finYear={finYear} meetingType={meetingType} />
      ) : !isZpSelected ? (
        <ZillaDashboard2 finYear={finYear} meetingType={meetingType} />
      ) : (
        <MomPage 
  finYear={finYear} 
  meetingType={meetingType} />
      )}
    </>
  );
};

export default ZillaParentDashboard;
